import createFactory from './create-factory';
import create from './create';
import extend from './extend';

export {
  createFactory,
  create,
  extend,
};
